import React from "react";
import Newnabar from "../components/shared/Newnabar";
import NewHero from "../components/home/NewHero";
import HowItWorksSteps from "../components/home/HowItWorksSteps";
import MoreThanApp from "../components/home/MoreThanApp";
import PopularDestinations from "../components/home/PopularDestinations";
import CommunityBanner from "../components/home/CommunityBanner";
import SafetyPriority from "../components/home/SafetyPriority";
import AIAssistantSection from "../components/home/AIAssistantSection";
import TestimonialsCarousel from "../components/home/TestimonialsCarousel";
import DownloadBanner from "../components/home/DownloadBanner";
import SoloConnectFooter from "../components/shared/SoloConnectFooter";
import SoloConnectMobileFooter from "../components/shared/SoloConnectMobileFooter";
import SEO from "../seo/SEO";

export default function Home() {
  return (
    <div className="scroll-smooth bg-slate-50 text-slate-800 font-sans min-h-screen">
      <SEO
        title="SoloConnect - Solo Travel App | Find Travel Buddies & Explore Together"
        description="Join SoloConnect to find verified travel buddies, connect with solo travelers, discover trips, and explore destinations safely. Available on Android and iOS."
        keywords="solo travel, travel buddy, find travel companion, meet solo travelers, travel app"
      />

      {/* NAVBAR */}
      <Newnabar />

      {/* HERO SECTION */}
      <NewHero />

      {/* HOW IT WORKS */}
      <HowItWorksSteps />

      {/* WHY SOLO CONNECT */}
      <MoreThanApp />

      {/* POPULAR DESTINATIONS */}
      <PopularDestinations />

      {/* COMMUNITY SECTION */}
      <div data-aos="fade-up">
        <CommunityBanner />
      </div>

      {/* SAFETY IS OUR PRIORITY */}
      <SafetyPriority />

      {/* AI TRIP ASSISTANT */}
      <div data-aos="fade-up">
        <AIAssistantSection />
      </div>

      {/* TESTIMONIALS */}
      <div data-aos="fade-up">
        <TestimonialsCarousel />
      </div>

      {/* DOWNLOAD APP BANNER */}
      <div data-aos="fade-up">
        <DownloadBanner />
      </div>

      {/* FOOTER */}
      <div className="hidden md:block" data-aos="fade-up">
        <SoloConnectFooter />
      </div>
      <div className="block md:hidden" data-aos="fade-up">
        <SoloConnectMobileFooter />
      </div>
    </div>
  );
}
